"use client";

import { QueryClient, QueryClientProvider } from "@stadium/services/react-query";

const clientQuery = new QueryClient();

const ReactQueryClient = ({ children }) => (
  <QueryClientProvider client={clientQuery}>{children}</QueryClientProvider>
);

export default ReactQueryClient;
